<div class="header-wrapper">
  <div class="logo-container">
    <div class="first-logo-left">
      <app-logo
        [size]="'large'"
        role="button"
        (click)="onLogoClick()"
      ></app-logo>
    </div>
    <div class="second-logo-left">
      <img src="./assets/images/login/isolation-mode-reversed.svg" alt="" />
    </div>
  </div>
  <div class="page-header-container">
    <div class="language-container">
      <app-language-switcher></app-language-switcher>
    </div>
    <div [hidden]="!title" class="page-title-container">
      <service-header [title]="title | translate"></service-header>
    </div>
  </div>
</div>
